import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { PENDING, IDLE, TEXT, YES_NO, MULTIPLE } from "const"
import { CcComplianceHistory } from "server/models"
import {
    StoreType,
    ComplianceHistoryValidation,

    UpdateCcComplianceHistoryResponse,
    LoadCcComplianceHistory,
    setCcComplianceItemHistory,
} from "client/store"
import { StateType } from "client/utils"
import {
    PageForm,
    FormGroup,
    Label,
    Delimiter,
    LinkButton,
    Textarea,
    Button,
    ButtonGroup,
    ButtonGroupItem,
    Feedback,
    SpinnerIcon,

    PrepareNestedHistory,
    NestedHistory,
    HistoryList,

    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmBottom,
} from "client/components"

const History = () => {
    const item = useSelector((state: StoreType) => state.ccCompliance.itemDetails)
    const history = useSelector((state: StoreType) => state.ccCompliance.itemHistory)
    const responseList = useSelector((state: StoreType) => state.ccResponse.responseList)
    const moduleResponseList = useSelector((state: StoreType) => state.ccResponse.moduleResponseList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const responseIds = moduleResponseList[1]
    const responsibleResponseIds = moduleResponseList[0]

    const [hidePrev, setHidePrev] = useState(true)
    const [nestedHistory, setNestedHistory] = useState<NestedHistory[]>([])
    const [historyRow, setHistoryRow] = useState<CcComplianceHistory>(null)
    const [responseId, setResponseId] = useState<number>(null)
    const [answer, setAnswer] = useState<string>(null)

    const [validation, setValidation] = useState<ComplianceHistoryValidation>(null)
    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        const nested = PrepareNestedHistory(history)
        setNestedHistory(nested)
    }, [history])

    const showHideHistory = () => {
        setHidePrev(!hidePrev)
    }

    const onEditAnswer = (row: CcComplianceHistory) => {
        setHistoryRow(row)
        if (row.responseId) setResponseId(row.responseId)
        else setAnswer(row.answer)
    }

    const stopEditAnswer = () => {
        setHistoryRow(null)
        setResponseId(null)
        setAnswer(null)
    }

    const onSaveAnswer = () => {
        setSaveState(PENDING)
        UpdateCcComplianceHistoryResponse(historyRow.id, responseId, answer, lang)
        .then((resValidation) => {
            setValidation(resValidation)
            if (resValidation) {
                setSaveState(IDLE)
                return
            }

            LoadCcComplianceHistory(historyRow.itemId, historyRow.complianceRevisionId).then((resHistory) => {
                dispatch(setCcComplianceItemHistory(resHistory))

                setSaveState(IDLE)
                stopEditAnswer()
            })
        })
    }

    const options: string[] = []
    if (item.options.length > 0) {
        const optionsSplited = item.options.split("\n")
        optionsSplited.forEach((row) => {
            const option = row.trim()
            if (option.length > 0) options.push(option)
        })
    }

    return (
        <PageForm noPaddingTop>
            <Row>
                <Col xs={12}>
                    <Delimiter />
                    <FormGroup>
                        <Label>{lang.history}</Label>
                    </FormGroup>

                    {
                        nestedHistory.length > 1 && (
                            <p>
                                <LinkButton onClick={showHideHistory}>
                                    {hidePrev ? lang.showPrevious : lang.hidePrevious}
                                </LinkButton>
                            </p>
                        )
                    }

                    <HistoryList
                        nested={hidePrev && nestedHistory.length > 1
                            ? [nestedHistory[nestedHistory.length - 1]]
                            : nestedHistory}
                        onEditAnswer={onEditAnswer}
                    />
                </Col>
            </Row>

            <ConfirmWrapper
                show={historyRow !== null}
                onClose={stopEditAnswer}
            >
                <Confirm>
                    <ConfirmTitle>{lang.updateResponse}</ConfirmTitle>
                    <Row>
                        <Col xs={12}>
                            {
                                // answer for responsible
                                historyRow && historyRow.parentId === null && (
                                    <FormGroup>
                                        <Label>{lang.answer}</Label>
                                        {
                                            item.answerType === TEXT
                                            && <Textarea value={answer} onChange={(e) => setAnswer(e.target.value)} />
                                        }
                                        {
                                            item.answerType === YES_NO && (
                                                <ButtonGroup>
                                                    {
                                                        responsibleResponseIds.map((id) => (
                                                            <ButtonGroupItem
                                                                key={id}
                                                                active={responseId === id}
                                                                onClick={() => setResponseId(id)}
                                                            >
                                                                {responseList[id] ? responseList[id].response : ""}
                                                            </ButtonGroupItem>
                                                        ))
                                                    }
                                                </ButtonGroup>
                                            )
                                        }
                                        {
                                            item.answerType === MULTIPLE && (
                                                <ButtonGroup>
                                                    {
                                                        options.map((option) => (
                                                            <ButtonGroupItem
                                                                key={option}
                                                                active={answer === option}
                                                                onClick={() => setAnswer(option)}
                                                            >
                                                                {option}
                                                            </ButtonGroupItem>
                                                        ))
                                                    }
                                                </ButtonGroup>
                                            )
                                        }
                                        <Feedback>{validation && validation.answer}</Feedback>
                                        <Feedback>{validation && validation.responseId}</Feedback>
                                    </FormGroup>
                                )
                            }
                            {
                                // responses for verifiers
                                historyRow && historyRow.parentId !== null && (
                                    <FormGroup>
                                        <Label>{lang.response}</Label>
                                        <ButtonGroup>
                                            {
                                                responseIds.map((id) => (
                                                    <ButtonGroupItem
                                                        key={id}
                                                        active={responseId === id}
                                                        onClick={() => setResponseId(id)}
                                                    >
                                                        {responseList[id] ? responseList[id].response : ""}
                                                    </ButtonGroupItem>
                                                ))
                                            }
                                        </ButtonGroup>
                                        <Feedback>{validation && validation.responseId}</Feedback>
                                    </FormGroup>
                                )
                            }
                        </Col>
                    </Row>

                    <ConfirmBottom>
                        <Button row onClick={stopEditAnswer}>{lang.cancel}</Button>
                        <Button variant="success" row onClick={onSaveAnswer}>
                            {saveState === PENDING ? <SpinnerIcon /> : lang.confirm}
                        </Button>
                    </ConfirmBottom>
                </Confirm>
            </ConfirmWrapper>
        </PageForm>

    )
}
export default History
